import React from 'react';
import './cookieConsent.css';

function CookieConsentView({onAcceptAll, onAcceptNecessary, onMoreSettings}) {
    return (
        <div className="cc-banner" role="dialog" aria-label="Cookie Consent">
            <div className="cc-banner-inner">
                <div className="cc-banner-left">
                    {/*<div className="cc-icon" aria-hidden="true">🍪</div>*/}
                    <div className="cc-text">
                        <h6 className="cc-title">We use cookies</h6>
                        <p className="cc-description">
                            We use cookies to enhance your browsing experience, serve personalised content, and
                            analyse our traffic. By clicking "Accept All", you consent to our use of cookies.
                            we use and how you can manage them. Read our{' '}
                            <a href="/privacy-policy" className="cc-link">Privacy Policy</a> to learn more.
                        </p>
                    </div>
                </div>
                <div className="cc-banner-actions">
                    <button
                        className="cc-btn cc-btn-accept-all"
                        onClick={onAcceptAll}
                    >
                        Accept All
                    </button>
                    <button
                        className="cc-btn cc-btn-necessary"
                        onClick={onAcceptNecessary}
                    >
                        Accept Only Necessary
                    </button>
                    <button
                        className="cc-btn cc-btn-necessary"
                        onClick={onMoreSettings}
                    >
                        More Settings
                        {/*<i className="fa fa-sliders ms-2" aria-hidden="true"/>*/}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsentView;
